var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    rx: 10,
    fill: "#F7DBB3",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.9688 47.9688V26.0312H20.0312V47.9688H47.9688ZM41.9688 11.9688H46V16H47.9688C49.0312 16 49.9688 16.4062 50.7812 17.2188C51.5938 18.0312 52 18.9688 52 20.0312V47.9688C52 49.0312 51.5938 49.9688 50.7812 50.7812C49.9688 51.5938 49.0312 52 47.9688 52H20.0312C18.9062 52 17.9375 51.625 17.125 50.875C16.375 50.0625 16 49.0938 16 47.9688V20.0312C16 18.9688 16.375 18.0312 17.125 17.2188C17.9375 16.4062 18.9062 16 20.0312 16H22V11.9688H26.0312V16H41.9688V11.9688ZM44.0312 34V44.0312H34V34H44.0312Z",
    fill: "#FF9900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalIcon);
export default __webpack_public_path__ + "static/media/cal-icon.a8c89f2509eae87779487516e4ca9def.svg";
export { ForwardRef as ReactComponent };